// extracted by mini-css-extract-plugin
export default {"searchTemplatesWrapper":"SearchTemplate__searchTemplatesWrapper--3CfyD"};